module.exports = __webpack_public_path__ + "assets/cover_2_old.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/cover_2_old.jpg
 ** module id = 207
 ** module chunks = 1
 **/